/// <reference path="../../services/command.service.js" />
/// <reference path="../../services/command-execution.service.js" />
/// <reference path="../../services/command-execution-log.service.js" />
const mod = require('../../bahabot.module.js')

function bbCommandExecutionLogsController(CommandService, CommandExecutionService, CommandExecutionLogService, $routeParams, $location) {
    this.location = $location;
    this.params = $routeParams;

    this.logSvc = CommandExecutionLogService;

    this.loading = true;
    this.error = null;

    this.command = null;
    this.execution = null;
    
    this.logSvc.filters.executionId = $routeParams.executionId;
    this.logSvc.fetch();

    this.loadMoreLogs = function () {
        this.logSvc.fetchMore().then((newLogs) => {
            this.logs.push(...newLogs);
            if (newLogs.length === 0) this.hasMoreLogs = false;
        });
    };

    this.goBack = function() {
        window.history.back();
    }

    // get the execution and command
    CommandExecutionService
        .get($routeParams.executionId)
        .then((r) => {
            this.execution = r;
            return CommandService.get(r.commandId)
        })
        .then((r) => {
            this.command = r;
        })
        .catch((e) => {
            console.error(e)
        })
        .finally(() => {
            this.loading = false;
        })
}

mod.component('bbCommandExecutionLogs', {
    templateUrl: 'tpl/bb-command-execution-logs.component.html',
    controller: ["CommandService", "CommandExecutionService", "CommandExecutionLogService", "$routeParams", "$location", bbCommandExecutionLogsController],
});